<template>
  <div class="content-wrapper">
    <app-overlay-loader v-if="preloader" />
    <div class="row" :class="{ 'loading-opacity': preloader }">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Pago de licencia"
          directory=""
          :icon="'trello'"
        />
      </div>

      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
          <button
            type="button"
            class="btn btn-success btn-with-shadow ml-3"
            @click="openDeleteModal"
          >
            Procesar
          </button>
        </div>
      </div>

      <div class="col-md-12">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
    </div>
    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </div>
</template>

<script>
import { axiosPost } from "../../../../../../../../resources/js/app/helpers/AxiosHelper";
export default {
  props: {
    accAppId: String,
  },
  data() {
    return {
      preloader: false,
      app_type: "",
      icon: "settings",
      tabsHorizontal: [
        {
          icon: "briefcase",
          name: "Ingreso de comprobante de pago",
          component: "payment-edit",
          permission: "",
        },
      ],
      deleteConfirmationModalActive: false,
      deleteLoader: false,
    };
  },
  created() {
    this.$store.state.accreditation.id = this.accAppId;
  },
  methods: {
    returnPage() {
      window.location.href = `/accreditations/applications`;
    },

    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      this.preloader = true;
      axiosPost(
        `/accreditations/applications/payment/store/${this.accAppId}`
      ).then((response) => {

        if (response.data.status == true) {
          this.deleteLoader = false;
          $("#modal-confirm-id").modal("hide");
          this.cancelled();
          if (response.data.data === "OK") {
            this.$toastr.s("Registro procesado con exito");
            this.returnPage();
            this.preloader = false;
          } else {
            this.$toastr.e(response.data.data);
            this.preloader = false;
          }
        }
      });
    },

    cancelled() {
      this.deleteConfirmationModalActive = false;
    },
  },
};
</script>